import { render, staticRenderFns } from "./AccountingBooksList.vue?vue&type=template&id=2d33ce13&"
import script from "./AccountingBooksList.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksList.vue?vue&type=style&index=0&id=2d33ce13&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports